<template>
    <b-card no-body>
      <b-card-header class="border-0">
        <b-row >
          <b-col cols="6">
            <h3 class="mb-0">Customer Financial Proposal
              <base-button v-show="$route.params.customer_id" type="primary" icon size="sm" @click.prevent="showAllfinancialProposalList()">Show All List</base-button>
            </h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between">
        <el-select
          class="select-primary pagination-select p-2"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
  
        <div class="p-2">
          <base-input v-model="searchQuery"
            v-on:input="debouncedHandler"
                      prepend-icon="fas fa-search"
                      placeholder="Search...(case-sensitive)">
          </base-input>
        </div>
      </b-col>
      <el-table class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="queriedData"
                @sort-change="sortChange"
                @selection-change="selectionChange"
                row-key="id">
        <el-table-column label="id"
                         min-width="60px"
                         prop="financial_proposal_id"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.financial_proposal_id}}</b>
          </template>
        </el-table-column>
  
        <el-table-column label="Customer Name"
                         prop="customer_name"
                         min-width="150px"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.customer_name}}</b>
          </template>
        </el-table-column>

        <el-table-column label="Agent Name"
                         prop="agent_name"
                         min-width="150px"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.agent_name}}</b>
          </template>
        </el-table-column>

        <el-table-column label="Financial Proposal Report"
                         prop="file_attach"
                         min-width="150px"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.financial_proposal_file.attach_file}}</b>
          </template>
        </el-table-column>
  
        <el-table-column label="Created By"
                         min-width="150px"
                         prop="created_by"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.created_by.name}}</b>
          </template>
        </el-table-column>
        <el-table-column label="Created At"
                         min-width="100px"
                         prop="created_at"
                         sortable>
          <template v-slot="{row}">
            <b>{{row.created_at}}</b>
          </template>
        </el-table-column>
  
        <el-table-column min-width="80px" align="center">
          <div slot-scope="{row}" class="table-actions btn-group-vertical">
            <base-button type="primary" icon size="sm" @click.prevent="onEdit(row)">
              <!-- <span class="btn-inner--icon"><i class="fas fa-edit"></i></span> -->
              <span class="btn-inner--text">Edit</span>
            </base-button>
            <base-button v-if="row.financial_proposal_file.attach_file" type="primary" icon size="sm" @click.prevent="onDownload(row)">
              <!-- <span class="btn-inner--icon"><i class="fas fa-edit"></i></span> -->
              <span class="btn-inner--text">Download</span>
            </base-button>
          </div>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
  
            <span v-if="selectedRows.length">
              &nbsp; &nbsp; {{selectedRows.length}} rows selected
            </span>
          </p>
  
        </div>
        <base-pagination
          class="pagination-no-border"
          :current="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
          @change="paginationChanged($event)"
        >
        </base-pagination>
      </div>
  
    </b-card>
  
  </template>
  <script>
    import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option } from 'element-ui'
    import axios from 'axios'
    import {apiGatewayDomain, getHeader} from '@/assets/js/config.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    import { BasePagination } from '@/components';
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import debounce from 'lodash.debounce';
  
    export default {
      name: 'customer-financial-proposal-table',
      mixins: [notifyFunctionMixin,clientPaginationMixin],
      components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
      },
      data() {
        return {
          propsToSearch:['customer_name'],
          tableData: [],
          currentPage: 1,
          mode: 'listing',
          selectedRows: [],
          searchText: '',
          debouncedHandler: '',
          TableColumn:[{
            type: 'selection'
          }]
        };
      },
      created(){
        this.financialProposalList();
      },
      mounted(){
        this.debouncedHandler = debounce(() => {
          // this.searchFinancialProposalList();
        }, 500);
      },
      methods: {
        paginationChanged(page) {
          this.pagination.currentPage = page
        },
        selectionChange(selectedRows) {
          this.selectedRows = selectedRows
        },
        showAllfinancialProposalList() {
          axios.get(apiGatewayDomain + 'financial_proposal/financial_proposal', { headers: getHeader() })
          .then(response => {
            this.tableData = response.data.data
          })
          .catch ( error => {
              console.log(error.response.status)
              this.errorFunction(error, "Show Financial Proposal") 
          });
        },
        financialProposalList(){
          if(this.$route.params.customer_id)
          {
            axios.get(apiGatewayDomain + 'financial_proposal/get_financial_proposal_by_customer_id/' + this.$route.params.customer_id, { headers: getHeader() })
            .then(response => {
              this.tableData = response.data.data
            })
            .catch ( error => {
                console.log(error.response.status)
                this.errorFunction(error, "Show Financial Proposal") 
            });
          }
          else
          {
            axios.get(apiGatewayDomain + 'financial_proposal/financial_proposal', { headers: getHeader() })
            .then(response => {
              this.tableData = response.data.data
            })
            .catch ( error => {
                console.log(error.response.status)
                this.errorFunction(error, "Show Financial Proposal") 
            });
          }
          
          // const str = JSON.stringify(this.tableData, null, 2);
          // console.log(str);
        },
        searchFinancialProposalList()
        {
          const postData = {
            controller_name : "FinancialProposalController",
            search_text : this.searchText,
            table_column: ["customer_name"]
          }
  
          axios.post(apiGatewayDomain + 'setup/data_search', postData  ,{ headers: getHeader() })
          .then ( response => {
            if(response.data.data.length === 0){
              return this.$notify({
                message:
                  '<b>Financial Proposal : </b> - No Results.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
              });
            }
            if (response.status === 200)
            {
              this.tableData = response.data.data
              console.log(this.tableData)
              this.$notify({
                message:
                  '<b>Financial Proposal : </b> - Search Successful.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
              });
  
            }
          })
          .catch ( error => {
              console.log(error.response.status)
              this.errorFunction(error, "Financial Proposal Listing")
          });
        },
        onEdit(row) {
          // let route = this.$router.resolve({path: '/financial_proposal/' + row.im2u_customer_id + '/' + row.financial_proposal_id});
          // window.open(route.href, '_blank');
          this.$router.push({path: '/financial_proposal/' + row.im2u_customer_id + '/' + row.financial_proposal_id})
        },
        onDownload(row) {
          axios.get(apiGatewayDomain + 'financial_proposal/download_financial_proposal_report/' + row.financial_proposal_file.financial_proposal_file_id ,{ headers: getHeader(), responseType: "blob" })
            .then ( response => {
            if (response.status === 200)
            {
                var FILE = window.URL.createObjectURL(new Blob([response.data]));        
                var docUrl = document.createElement('a');

                docUrl.href = FILE;
                docUrl.setAttribute('download', row.financial_proposal_file.attach_file);
                document.body.appendChild(docUrl);
                docUrl.click();
            }
            })
            .catch ( error => {
                console.log(error.response.status)
                this.errorFunction(error, "Download Financial Proposal Report")
            });
        }
  
      }
    }
  </script>
  